import React from "react";
import ReactDOM from "react-dom/client";
import Router from "./Router";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider, UrlParamsProvider } from "src/contexts";
import "./i18n";
import "./index.scss";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

root.render(
  <BrowserRouter>
    <UrlParamsProvider>
      <ThemeProvider>
        <Router />
      </ThemeProvider>
    </UrlParamsProvider>
  </BrowserRouter>
);
